<template>
    <div id="login-sso">
        <div v-if="error" class="error-message" :innerText="error"></div>
        <Loader v-else />
    </div>
</template>

<script lang="ts" setup>
import { LoginApi } from '@/openapi-clients-generated/auth';
import Loader from '@/shared/components/loader.vue';
import { broadcastMessage } from '@/shared/helpers/broadcast.helpers';
import { handleErrorAndAlert } from '@signal24/vue-foundation';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const error = ref<string>();
const isCallbackUrl = router.currentRoute.value.name === 'login:callback';

async function startSso() {
    const provider = router.currentRoute.value.query.provider as 'azure' | 'google';
    try {
        const { data } = await LoginApi.postLoginLogin({
            body: {
                provider,
                redirectUrl: `${location.origin}/login/callback`
            }
        });
        location.href = data!.authorizeUrl!;
    } catch (err) {
        handleErrorAndAlert(err);
    }
}

function doCallback() {
    broadcastMessage('login', router.currentRoute.value.query);
    window.close();
}

onMounted(() => {
    if (isCallbackUrl) {
        doCallback();
    } else {
        startSso();
    }
});
</script>
